export default __webpack_public_path__ + "static/media/nope-3.587d8b21.gif";